import { FC } from "react";
import { AccessListProps, AccessListVariant } from "./types";
import { Column } from "../../../../../components/containers";
import { Heading } from "../../../../../components/typography";
import { useThemeStore } from "../../../../../stores";
import { AlignItems } from "../../../../../components/containers/types";
import { CheckBox } from "../../../../../components/inputs";
import { ACCESS_FA, ALL_ACCESS } from "../../../../../utils";
import { Access } from "../../types";

const AccessList: FC<AccessListProps> = ({
  accessList,
  props,
  className = "",
  readOnly = false,
  style = {},
  updateAccessList = () => {},
  variant = AccessListVariant.Big,
  title = "سطح دسترسی",
}) => {
  const theme = useThemeStore((state) => state.theme);

  const onUpdateAccess = (access: Access, value: boolean): void => {
    updateAccessList((prev) => {
      if (value && !prev.includes(access)) {
        prev.push(access);
      } else if (!value && prev.includes(access)) {
        prev = prev.filter((a) => a !== access);
      }
      return [...prev];
    });
  };

  return (
    <Column
      style={{ width: "100%", ...style }}
      alignItems={AlignItems.Start}
      gap={10}
      props={props}
      className={className}
    >
      <Heading
        color={theme.textOnBg}
        size={variant === AccessListVariant.Big ? 20 : 15}
      >
        {title}
      </Heading>
      {ALL_ACCESS.map((access, idx) => (
        <CheckBox
          key={access}
          color={theme.textOnBg}
          label={ACCESS_FA[idx]}
          readOnly={readOnly}
          value={accessList.includes(access)}
          setValue={(value) => onUpdateAccess(access, value)}
          size={variant === AccessListVariant.Big ? 16 : 11}
        />
      ))}
    </Column>
  );
};

export default AccessList;
